module.exports = __webpack_public_path__ + "static/media/4. G14. Superficie sólida. 23 x 43 x 18 cm. 2021 copy.8336bc09.png";